import React, { useState } from "react";
import Box from "@mui/material/Box";
//import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

//import IconButton from "@mui/material/IconButton";
const dashboard = () => {
    window.location.href = "/dashboardAdminItalika";
    };

function EnvioerrorMasivoItalika() {
    
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5%",
      }}
    >
      <Container maxWidth="sm">
      <Alert
              style={{ marginBottom: "20px" }}
              severity="error" 
            >
              
            </Alert>
            <button onClick={dashboard}>Regresar</button>
      </Container>
    </Box>
  );
}

export default EnvioerrorMasivoItalika;



